/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliverySlotsResponseSchema } from "./deliverySlotsResponseSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { kindEnumSchema } from "./kindEnumSchema.ts";

export const orgUnitDeliverySlotsRetrieveQueryDateSchema = z.iso.date();

export const orgUnitDeliverySlotsRetrieveQueryKindSchema = kindEnumSchema.describe("* `courier` - Доставка курьером\n* `pickup` - Самовывоз");

export const orgUnitDeliverySlotsRetrievePathOrgUnitIdSchema = z.uuid();

export const orgUnitDeliverySlotsRetrieveStatus200Schema = deliverySlotsResponseSchema;

export const orgUnitDeliverySlotsRetrieveStatus400Schema = errorResponseSchema;

export const orgUnitDeliverySlotsRetrieveResponseSchema = z.union([orgUnitDeliverySlotsRetrieveStatus200Schema, orgUnitDeliverySlotsRetrieveStatus400Schema]);
